import AudioPlayer from '../../../../../../components/audioplayer/audioplayer';
import mollybloom from '../../../../../../assets/mollybloom.jpg';
import './jan13.css';


export default function Jan13() {

  return (

  
    < >
    
 
    
    <p className = 'sentence'> Consume everything that you can. <br></br>Watch good tv shows, read good books, listen to lots of music, eat good food, have good conversations, meet interesting people, go on epic adventures. <br></br><br></br>

Aim to have your own perspectives and opinions.<br></br> Build your view from the ground up. <br></br><br></br>
Do not limit action.Take the hard skills and inspiration that you have and create something unique.<br></br> Make something that invokes your point of view.<br></br> Show others why your creation is great. Keep the cycle alive. <br></br>“There is no humiliation worse than the wasted life”. <br></br><br></br>

Take a point of view outside of yourself, do not let yourself stay yourself, always question yourself.<br></br> Put him in uncomfortable scenarios, challenge and inspire him. <br></br><br></br>

Everything is a source of inspiration if you want it to be. <br></br>There is as much to learn at a museum as there is at a rave. <br></br><br></br>


 <img
    src={mollybloom}
    alt="center"
    className = "img"
  />

<br></br><br></br>
Let your mind wander and build fantasy. <br></br>Stray further into the depths of the things that you like. <br></br>Ask questions that you are curious about, even if they seem pointless. <br></br><br></br>

It is impossible to know. <br></br>Do not concern yourself with knowing.<br></br> Instead, concern yourself with fluidity of mind and body.<br></br><br></br>

Don’t think so hard, it quickly becomes a burden.<br></br> Instead feel more and let those feelings move your decisions.<br></br> That will bring you closer to clarity of self. <br></br><br></br>

Take advice with a boulder of salt.<br></br> Everyone is projecting everything all of the time, and it is very easy to get lost in somebody else’s world.<br></br> Stick to your guns, die by your sword if need be, but also be open to change and have an open perspective. <br></br><br></br>
  </p>
  <div className = "youtube">
  <br></br>youtube: <a href = "https://www.youtube.com/@AugustDiStefano" target = "_blank" rel = "noopener noreferrer">
      https://www.youtube.com/@AugustDiStefano 
    </a>

    </div>
    </>

  )
}
